import React from 'react';
import { Link } from 'react-router-dom';
import useMain from '../../../../hooks/useMain';
import { TextCard } from '../../ingredients/cards';

const News = () => {
	const { dashboardBlogs, theme } = useMain();

	return (
		<div className='col-lg-6'>
			{dashboardBlogs && dashboardBlogs[0] && (
				<TextCard
					titleClass={'text-center mb-4'}
					title={'Latest News'}
					text={
						<>
							<hr />
							<div className='row align-items-center my-5'>
								<div className='col-sm-5 text-center'>
									<img
										loading='lazy'
										src={dashboardBlogs[0].thumbLink}
										className='w-100 rounded'
										alt={dashboardBlogs[0]._id}
										crossOrigin='true'
									/>
								</div>
								<div className='col-sm-7'>
									<h5>{dashboardBlogs[0].title}</h5>
									<p>
										{dashboardBlogs[0].description}
										<br />
										<Link
											className={`btn btn-set2-${theme} mt-2`}
											to={{
												pathname: '/dashboard/news',
												state: {
													_id: dashboardBlogs[0]._id,
												},
											}}>
											Read More ...
										</Link>
									</p>
									<div className='fs-6 opacity-50'>
										{new Date(dashboardBlogs[0].date).toLocaleDateString()}
									</div>
								</div>
							</div>

							<div className='row align-items-center mb-4'>
								<div className='col-sm-5 text-center'>
									<img
										loading='lazy'
										src={dashboardBlogs[1].thumbLink}
										className='w-100 rounded'
										alt={dashboardBlogs[1]._id}
										crossOrigin='true'
									/>
								</div>
								<div className='col-sm-7'>
									<h5>{dashboardBlogs[1].title}</h5>
									<p>
										{dashboardBlogs[1].description}
										<br />
										<Link
											className={`btn btn-set2-${theme} mt-2`}
											to={{
												pathname: '/dashboard/news',
												state: {
													_id: dashboardBlogs[1]._id,
												},
											}}>
											Read More ...
										</Link>
									</p>
									<div className='fs-6 opacity-50'>
										{new Date(dashboardBlogs[1].date).toLocaleDateString()}
									</div>
								</div>
							</div>
						</>
					}
				/>
			)}
		</div>
	);
};

export default News;
